module.exports = ".mr--5px {\n  margin-right: 5px; }\n\n.mb--20px {\n  margin-bottom: 20px; }\n\n.consent--wrapper {\n  padding: 0 10px; }\n\n.consent--wrapper ul {\n    padding: 0 10px; }\n\n.consent--wrapper ul li {\n      margin-bottom: 5px; }\n\n.consent--wrapper ol {\n    padding: 0 10px; }\n\n.consent--wrapper ol li {\n      margin-bottom: 10px; }\n\n.consent--wrapper p {\n    margin-bottom: 10px;\n    margin-top: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/patient-consent-to-draw/patient-consent-to-draw.component.scss
// module id = ./src/app/shared/components/patient-consent-to-draw/patient-consent-to-draw.component.scss
// module chunks = main